// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lUIaj","content":"styles_content__CTN0L","innerContent":"styles_innerContent__gVwoo"};